import React from 'react';
import VendorHero from '../components/vendor-info/VendorHero';
import Section2 from '../components/vendor-info/S2VI';
import S3VI from '../components/vendor-info/S3VI';
import S4VI from '../components/vendor-info/S4VI';
import S5VI from '../components/vendor-info/S5VI';
import S6VI from '../components/vendor-info/S6VI';

const VendorInfo = () => {
  return (
    <main className="vendorinfo-page" role="main">
      <VendorHero/>
      <Section2 />
      <S3VI />
      <S4VI />
      <S5VI />
      <S6VI />
    </main>
  );
};
export default VendorInfo;